module.exports = __webpack_public_path__ + "img/bg_login_LL.12ed4453.png";